import moodhound from '../../assets/projects/moodhound.png';
import owlPartners from '../../assets/projects/owlPartners.png';
import cloudFox from '../../assets/projects/cloudFox.png';
import gabevents from '../../assets/projects/gabevents.svg';
import eleitorado from '../../assets/projects/eleitorado.png';

export const projectsList_ptBR = [
  {
    "title": 'Mood Hound (FATEC)',
    "imgSrc": moodhound,
    "githubURL": 'https://github.com/The-Bugger-Ducks/mood-hound-documentation',
    // "prodURL": 'https://owl-partners.netlify.app/',
    "prodURL": null,
    "description": "Construído no  6º Semestre do Curso. Uma Dashboard que utiliza inteligência artificial baseada em processamento de linguagem natural para analisar os comentários dos usuários, classificando suas emoções.",
    "techs": ['Python', 'Word2Vec', 'PyUnit', 'Jest', 'TFIDF', 'Typescript', 'NestJS', 'Docker', 'React', 'MongoDB', 'Swagger']
  },
  {
    "title": 'OwlParners (FATEC)',
    "imgSrc": owlPartners,
    "githubURL": 'https://github.com/The-Bugger-Ducks/owl-partners-documentation',
    "prodURL": 'https://owl-partners.netlify.app/',
    // "prodURL": null,
    "description": "Construído no  5º Semestre do Curso. Uma Plataforma de venda de ingressos para shows. Permite aos usuários navegar e comprar ingressos para diversos eventos. Com uma interface fácil de usar.",
    "techs": ['Typescript', 'Node.js', 'NestJS', 'Prisma.io', 'Docker', 'React', 'PostgreSQL', 'Swagger']
  },
  {
    "title": 'CloudFox (FATEC)',
    "imgSrc": cloudFox,
    "githubURL": 'https://github.com/The-Bugger-Ducks/cloud-fox-documentation/',
    "prodURL": 'https://cloud-fox.netlify.app/',
    // "prodURL": null,
    "description": "Construído no  4º Semestre do Curso. Um Sistema robusto e completo para observação e análise de dados meteorológicos, oferecendo recursos avançados e customizáveis para atender às necessidades.",
    "techs": ['IOT', 'C++', 'Arduino', 'Typescript', 'React', 'Node.js', 'TypeORM', 'PostgreSQL']
  },
  {
    "title": 'GabEvents',
    "imgSrc": gabevents,
    "githubURL": 'https://github.com/GabrielCamargoL/GabEvents',
    "prodURL": 'https://gabevents.netlify.app/',
    // "prodURL": null,
    "description": "Plataforma de venda de ingressos para shows. Permite aos usuários navegar e comprar ingressos para diversos eventos. Com uma interface fácil de usar.",
    "techs": ['Typescript', 'Node.js', 'TypeORM', 'React', 'MongoDB']
  },
  {
    "title": 'HelpDuck (FATEC)',
    "imgSrc": 'https://user-images.githubusercontent.com/55204419/180854589-2eca7130-cdd9-4ac4-b9e7-44ca0aaa55e3.png',
    "githubURL": 'https://github.com/The-Bugger-Ducks/help-duck-documentation',
    // "prodURL": 'https://help-duck.netlify.app/',
    "prodURL": null,
    "description": "Construído no  3º Semestre do Curso. Help Desk desenvolvido para gerenciar o ciclo de vida de um chamado, aplicando segurança com autorização e autenticação JWT",
    "techs": ['Typescript', 'React', 'Java', 'Spring Boot', 'Python', 'MongoDB']
  },
  {
    "title": 'Polaris (FATEC)',
    "imgSrc": 'https://user-images.githubusercontent.com/55204419/180854572-7bc7a04c-4d25-4e83-a423-42f849cb41ac.png',
    "githubURL": 'https://github.com/Equipe-Polaris-DSM-2021/docs',
    "prodURL": 'https://polaris-fatec.netlify.app/',
    "description": 'Construído no  2º Semestre do Curso. Aplicação de sensoriamento terrestre com dados de satélites Landsat-8, Sentinel-2 para oferecimento de tiles',
    "techs": ['Typescript', 'React', 'Leaflet', 'Node.js', 'Python', 'PostgreSQL']
  },
  {
    "title": 'Analise de Eleitorado (FATEC)',
    "imgSrc": eleitorado,
    "githubURL": 'https://github.com/fa-API-Group-02/project',
    "prodURL": null,
    "description": "Construído no  1º Semestre do Curso. Análise centrada em dados públicos do eleitorado do Estado de São Paulo, utilizando algoritmos de processamento de dados para extrair insights. Os resultados são apresentados de maneira clara e concisa por meio de um website",
    "techs": ['Python', 'Jupyter Notebook', 'Flask', 'Typescript', 'React', 'MySQL']
  },
  {
    "title": 'E-doctor mobile (ETEC)',
    "imgSrc": 'https://user-images.githubusercontent.com/55204419/180847181-5c549019-5243-4f76-be58-8709f2ad5d65.png',
    "githubURL": 'https://github.com/GabrielCamargoL/E-doctor_app-pacient',
    "prodURL": null,
    "description": 'Construído como TCC do Curso. Aplicativo mobile que gerencia consultas de profissionais da saúde, otimizando e agrupando-as em uma só plataforma, feito com React Native',
    "techs": ['Javascript', 'React Native']
  },
  {
    "title": 'E-doctor backend (ETEC)',
    "imgSrc": 'https://user-images.githubusercontent.com/55204419/180848638-fd9f4aaf-b471-495d-8ebb-4e611cfbacaf.png',
    "githubURL": 'https://github.com/GabrielCamargoL/E-doctor-api',
    "prodURL": null,
    "description": 'Construído como TCC do Curso. Backend para gerenciar dados e rotas para o aplicativo e-doctor consumir, feito com AdonisJS e AWS',
    "techs": ['Javascript', 'AdonisJS', 'AWS S3', 'MySQL']
  },
];


export const projectsList_enUS = [
  {
    "title": 'Mood Hound (FATEC)',
    "imgSrc": moodhound,
    "githubURL": 'https://github.com/The-Bugger-Ducks/mood-hound-documentation',
    // "prodURL": 'https://owl-partners.netlify.app/',
    "prodURL": null,
    "description": "Built in the 6th Semester of the Course. A Dashboard that uses natural language processing-based artificial intelligence to analyze user comments, classifying their emotions.",
    "techs": ['Python', 'Word2Vec', 'PyUnit', 'Jest', 'TFIDF', 'Typescript', 'NestJS', 'Docker', 'React', 'MongoDB', 'Swagger']
  },
  {
    "title": 'OwlParners (FATEC)',
    "imgSrc": owlPartners,
    "githubURL": 'https://github.com/The-Bugger-Ducks/owl-partners-documentation',
    "prodURL": 'https://owl-partners.netlify.app/',
    // "prodURL": null,
    "description": "Built in the 5th Semester of the Course. A Partnership management and meeting scheduling system. With this platform, it is possible to optimize the time of those involved, avoiding rework.",
    "techs": ['Typescript', 'Node.js', 'NestJS', 'Prisma.io', 'Docker', 'React', 'PostgreSQL', 'Swagger']
  },
  {
    "title": 'CloudFox (FATEC)',
    "imgSrc": cloudFox,
    "githubURL": 'https://github.com/The-Bugger-Ducks/cloud-fox-documentation/',
    "prodURL": 'https://cloud-fox.netlify.app/',
    // "prodURL": null,
    "description": "Built in the 4th Semester of the Course. A Robust and complete system for observing and analyzing meteorological data, offering advanced and customizable features to meet your needs.",
    "techs": ['IOT', 'C++', 'Arduino', 'Typescript', 'React', 'Node.js', 'TypeORM', 'PostgreSQL']
  },
  {
    "title": 'GabEvents',
    "imgSrc": gabevents,
    "githubURL": 'https://github.com/GabrielCamargoL/GabEvents',
    "prodURL": 'https://gabevents.netlify.app/',
    // "prodURL": null,
    "description": "Ticket-selling platform for shows. It allows users to browse and purchase tickets for various events. With an easy-to-use interface.",
    "techs": ['Typescript', 'Node.js', 'TypeORM', 'React', 'MongoDB']
  },
  {
    "title": 'HelpDuck (FATEC)',
    "imgSrc": 'https://user-images.githubusercontent.com/55204419/180854589-2eca7130-cdd9-4ac4-b9e7-44ca0aaa55e3.png',
    "githubURL": 'https://github.com/The-Bugger-Ducks/help-duck-documentation',
    // "prodURL": 'https://help-duck.netlify.app/',
    "prodURL": null,
    "description": "Built in the 3rd Semester of the Course. A Help Desk designed to manage the lifecycle of a ticket, enforcing security with authorization and JWT authentication",
    "techs": ['Typescript', 'React', 'Java', 'Spring Boot', 'Python', 'MongoDB']
  },
  {
    "title": 'Polaris (FATEC)',
    "imgSrc": 'https://user-images.githubusercontent.com/55204419/180854572-7bc7a04c-4d25-4e83-a423-42f849cb41ac.png',
    "githubURL": 'https://github.com/Equipe-Polaris-DSM-2021/docs',
    "prodURL": 'https://polaris-fatec.netlify.app/',
    "description": 'Built in the 2nd Semester of the Course. A Terrestrial sensing application with data from Landsat-8, Sentinel-2 satellites to offer tiles',
    "techs": ['Typescript', 'React', 'Leaflet', 'Node', 'Python']
  },
  {
    "title": 'Electorate Analysis (FATEC)',
    "imgSrc": eleitorado,
    "githubURL": 'https://github.com/fa-API-Group-02/project',
    "prodURL": null,
    "description": "Built in 1st Semester of the Course. A Analysis centered on public data of the electorate of the State of São Paulo. Using data processing algorithms to extract insights. The results are presented clearly and concisely through a website",
    "techs": ['Python', 'Jupyter Notebook', 'Flask', 'Typescript', 'React', 'MySQL']
  },
  {
    "title": 'E-doctor mobile app (ETEC)',
    "imgSrc": 'https://user-images.githubusercontent.com/55204419/180847181-5c549019-5243-4f76-be58-8709f2ad5d65.png',
    "githubURL": 'https://github.com/GabrielCamargoL/E-doctor_app-pacient',
    "prodURL": null,
    "description": 'Built as a Final Course Project. Mobile application that manages consultations from healthcare professionals, optimizing and grouping them on a single platform, made with React Native',
    "techs": ['Javascript', 'React Native']
  },
  {
    "title": 'E-doctor backend (ETEC)',
    "imgSrc": 'https://user-images.githubusercontent.com/55204419/180848638-fd9f4aaf-b471-495d-8ebb-4e611cfbacaf.png',
    "githubURL": 'https://github.com/GabrielCamargoL/E-doctor-api',
    "prodURL": null,
    "description": 'Built as a Final Course Project. Backend to manage data and routes for the e-doctor application to consume, made with AdonisJS and AWS',
    "techs": ['Javascript', 'AdonisJS', 'AWS S3', 'MySQL']
  },
];



